// import CssBaseline from '@mui/material/CssBaseline';

import useThemeSettings from '@webclient/hooks/useThemeSettings';

import '@fontsource/inter';

import { ThemeProvider as KnowzThemeProvider } from '@knowz/knowz-ui';

export default function ThemeProvider({ children }: React.PropsWithChildren) {
  const { themeMode } = useThemeSettings();
  const isThemeModeDark = themeMode === 'dark';

  return (
    <KnowzThemeProvider themeMode={isThemeModeDark ? 'dark' : 'light'}>
      {/* <CssBaseline /> */}
      {children}
    </KnowzThemeProvider>
  );
}
